import {Route, Routes} from 'react-router-dom';
import './App.css';
import ThankYouPage from "./pages/ThankYouPage";
import FailPage from "./pages/FailPage";
import TicketIframe from './pages/Iframe/TicketIframe';
// import ContractIframe from './pages/Iframe/ContractIframe';
import ChatbotIframe from './pages/Iframe/ChatbotIframe';
import ChatbotIframeProd from './pages/Iframe/ChatbotIframeProd';
import PercallIframe from "./pages/Iframe/PercallIframe";

function App() {
    return (
        <Routes>
            <Route path="/qa/c4c-ticket-payment" element={<TicketIframe />} />
            <Route path="c4c-ticket-payment" element={<TicketIframe />} />
            <Route path="per-call" element={<PercallIframe />} />
            {/* <Route path="contract" element={<ContractIframe />} /> */}

            <Route path="/chatbot" element={<ChatbotIframe />} />
            <Route path="/chat" element={<ChatbotIframeProd />} />

            <Route path="success" element={<ThankYouPage />} />
            <Route path="fail" element={<FailPage />} />
        </Routes>
    );
}

export default App;
